import { render, staticRenderFns } from "./ForgotPwdLayout.vue?vue&type=template&id=7fbd5781&scoped=true&"
import script from "./ForgotPwdLayout.vue?vue&type=script&lang=js&"
export * from "./ForgotPwdLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fbd5781",
  null
  
)

export default component.exports